import { Card } from '@/components/ui/card';
import { getS3Url } from '@/config/s3.config';
import { Exercise } from '@repo/types/src/glow-up';
import { DeleteExercise } from './DeleteExercise';
import { EditExercise } from './EditExercise';

type ExerciseCardProps = {
  exercise: Exercise;
  refetch: () => void;
};

export const ExerciseCard = ({ exercise, refetch }: ExerciseCardProps) => {
  return (
    <Card className="p-4 w-80 flex flex-col gap-4">
      <div className="aspect-video overflow-hidden rounded-lg">
        <img
          src={getS3Url(exercise.image)}
          alt={exercise.title}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="font-semibold text-lg">{exercise.title}</h3>
        <p className="text-sm text-gray-600 line-clamp-2">
          {exercise.description}
        </p>
        <div className="flex justify-between text-xs text-gray-500">
          <span>Durée: {exercise.duration} seconds</span>
          <span>Catégorie ID: {exercise.categoryId}</span>
        </div>
        {exercise.audio && (
          <a
            href={getS3Url(exercise.audio)}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-blue-600 hover:underline"
          >
            Voir la audio
          </a>
        )}
      </div>

      <div className="flex gap-2 mt-auto">
        <EditExercise exercise={exercise} refetch={refetch} />
        <DeleteExercise exercise={exercise} refetch={refetch} />
      </div>
    </Card>
  );
};
